import { render } from "./CommonTreeMenuItem.vue?vue&type=template&id=966b580e&scoped=true&ts=true"
import script from "./CommonTreeMenuItem.vue?vue&type=script&lang=ts"
export * from "./CommonTreeMenuItem.vue?vue&type=script&lang=ts"

import "./CommonTreeMenuItem.vue?vue&type=style&index=0&id=966b580e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966b580e"]])

export default __exports__